import sample_01 from './exclusiveClement.jpg';

export const exclusiveCementImpressions = {
    sample_01,
};
